"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFramerRefWorkaround = void 0;
const react_1 = require("react");
/* framer motion doesnt support updating refs automatically when the function changes, so this is the workaround to do that.
* this allows react-intersection-observer to work properly.
*/
function useFramerRefWorkaround(props) {
    const eleRef = react_1.useRef(null);
    const propRef = props.ref;
    react_1.useEffect(() => {
        propRef === null || propRef === void 0 ? void 0 : propRef(eleRef.current);
    }, [propRef, eleRef]);
    return eleRef;
}
exports.useFramerRefWorkaround = useFramerRefWorkaround;
